import type { FormikContextType } from 'formik'
import { noop } from 'lodash'

import type { SaveButtonProps } from '@/components/ConsoleDialog/ConsoleDialog.types'
import { FieldProps } from '@/types/forms'

export const areAnyTouchedFieldsInvalid = <Values>(formik: FormikContextType<Values>): boolean => {
  return Object.keys(formik.errors).some((errorField) =>
    Object.keys(formik.touched).some((touchedField) => touchedField === errorField)
  )
}

export const formikSaveButtonProps = <Values>(
  formik: FormikContextType<Values>
): SaveButtonProps => ({
  onClick: formik.isSubmitting ? noop : formik.submitForm,
  loading: formik.isSubmitting,
  disabled: !formik.dirty || !formik.isValid || Object.keys(formik.errors).length > 0,
  error: areAnyTouchedFieldsInvalid(formik),
  sx: {
    px: 1.5
  }
})

export const getFormError = <Values extends NonNullable<unknown>>(
  formik: FieldProps<Values>['formik'],
  name: FieldProps<Values>['name']
) => {
  return (formik.touched[name] && formik.errors[name]?.toString()) || undefined
}

export const onFieldChange = async <Values>(
  formik: FormikContextType<Values>,
  field: keyof Values & string,
  value: Values[typeof field],
  validateField = true
) => {
  return Promise.all([formik.setFieldValue(field, value), formik.setFieldTouched(field)]).then(
    () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      validateField && formik.validateField(field)
    }
  )
}
